import { connect } from 'react-redux';
import Files from './Files';
import { getAuthenticationToken } from '../../../../store/actions/authentication.actions';
import { getPersonFileListLoadingStatus, getPersonFilesList } from '../../../../store/selectors/person.selectors';
import {
    deletePersonFileDocumentBegin,
    downloadPersonFileDocumentBegin,
} from '../../../../store/actions/person.actions';

const mapStateToProps = (state: FileList) => {
    const data = getPersonFilesList(state);
    const loading = getPersonFileListLoadingStatus(state);
    return { data, loading };
};
const mapDispatchToProps = {
    deleteFileDocument: deletePersonFileDocumentBegin,
    downloadFileDocument: downloadPersonFileDocumentBegin,
    getAuthenticationToken: getAuthenticationToken,
};
export default connect(mapStateToProps, mapDispatchToProps)(Files);
